<template>
  <el-dropdown ref="dropdown" class="referral-type-select" :class="disabled && 'is-disabled'" trigger="click" @command="handleDropdownCommand">
    <div class="select-label">
      <label>{{ labelI18nKey && $t(labelI18nKey) }}</label>
      <span>{{ selectedOption ? $t(selectedOption.labelI18nKey) : '>' }}</span>
    </div>
    <el-dropdown-menu slot="dropdown" class="select-dropdown">
      <el-dropdown-item
        v-for="(option, index) in optionList"
        :key="index"
        :command="option"
      >
        {{ $t(option.labelI18nKey) }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import _ from 'lodash'

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      required: true
    },
    labelI18nKey: {
      required: false
    },
    optionList: {
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    selectedOption () {
      return _.find(this.optionList, { value: this.value })
    }
  },
  created () {

  },
  mounted () {
    if (this.disabled) {
      this.$refs.dropdown.triggerElm.disabled = true
    }
  },
  methods: {
    handleDropdownCommand (option) {
      if (this.disabled) {
        return
      }
      this.$emit('change', option.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.referral-type-select {
  border: 1px solid #e2e2e2;
  cursor: pointer;

  &:focus, &:hover {
    border-color: #66b1ff;
    color: #66b1ff;
  }

  &.is-disabled {
    cursor: not-allowed;

    &:focus, &:hover {
      border-color: #e2e2e2;
      color: inherit;
    }
  }

  .select-label {
    padding: 6px 15px;
    display: flex;

    label {
      margin-left: 0;
      margin-right: auto;
    }

    span {
      margin-left: auto;
      margin-right: 0;
    }
  }
}
.select-dropdown {
  width: 150px;
}
</style>
